import { Component, Input, input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ImgPlaceholderPipe } from '@coworkrz/shared/misc';

@Component({
  selector: 'ui-list-item',
  imports: [CommonModule, ImgPlaceholderPipe],
  templateUrl: './list-item.component.html',
})
export class ListItemComponent {
  @Input() image: string | null | undefined;
  readonly padding = input<number>();
  readonly isActive = input<boolean | null>(false);
  readonly doHaveImage = input(false);
  readonly isRemovable = input(false);
  readonly isRoundedBottom = input(false);
  readonly isRoundedTop = input(false);
}
